import React from 'react';
import { Spinner } from 'react-bootstrap';
import '../../css/loadingspin.css';
const LoadinSpin = ({ cen = 'loadcen' }) => {
    return (
        // <div className="d-flex justify-content-center mt-5 ">
        //     <Spinner className="text-primary m-2" color="primary" size="lg" />
        // </div>
        <div className={cen}>
            <span className="loader"></span>
        </div>
    );
};

export default LoadinSpin;
